export const Labels = {
  COMMON: {
    CLOSE: 'Close',
    CANCEL: 'Cancel',
    RESET: 'Reset',
    NEXT: 'Next',
    OK: 'OK',
    SUCCESS: 'Success',
    STEPS:{
        INITIATE:'Initiate',
        ANALYZED:'Analyzed',
        REVIEW:'Review',
        APPROVED:'Download'
    }
  },
  CREATE_REPORT_TYPE: {
    TITLE: 'Select Template',
    HELP_TEXT: 'To start, please make selections to find a template...',
    CLIENT_NAME: 'Client Name',
    SELECT_CLIENT: 'Select Client',
    CLIENT_REQUIRED: 'Client is required',
    REPORT_TYPE: 'Report Type',
    SELECT_REPORT_TYPE: 'Select Report Type',
    FIND_TEMPLATE: 'Find Template',
    TEMPLATES_FOUND: 'Templates Found',
    TEMPLATE_NAME: 'Template Name',
    DESCRIPTION: 'Description',
    VERSION: 'Version',
  },
  GENERATE_REPORT: {
    TITLE: 'Generate Report',
    HELP_TEXT: 'Please fill in the required fields to generate your report.',
    TEMPLATE_VARIABLES: 'Template Variables',
    REPORT_NAME: 'Report Name',
    REPORT_NAME_PLACEHOLDER: 'Enter Report Name',
    REPORT_NAME_REQUIRED: 'Report Name is required.',
    REPORT_NAME_MAX_LENGTH: 'Report Name must not exceed 100 characters.',
    PROJECT_ID: 'Project ID',
    PROJECT_ID_PLACEHOLDER: 'Enter 8-digit Project ID',
    PROJECT_ID_REQUIRED: 'Project ID is required.',
    PROJECT_ID_PATTERN: 'Project ID must be exactly 8 digits.',
    MULTISELECT_REQUIRED: 'At least one selection is required.',
    GENERATE_BUTTON: 'Generate Report',
    SUCCESS_MESSAGE: 'Report generation initiated successfully.',
  },
  COMPILE_EXPORT: {
    EYEBROW: 'Report Update · ',
    CCOMPILE_EXPORT:'Compile & Export',
    ORDER_TITLE: 'Attachment order & divider names',
    ORDER_HINT: 'Drag to set the order the appendices are assembled behind the report.',
    MOVE_UP: 'Move up',
    MOVE_DOWN: 'Move down',
    NO_DOCUMENTS: 'No supporting documents have been uploaded for this report.',
    UNSAVED_ORDER: 'Order changed — save it to keep this arrangement.',
    CONFIRMED_OF: 'of',
    CONFIRMED_SUFFIX: 'confirmed',
    DIVIDER_PREFIX: 'Divider:',
    DIVIDER_READONLY: 'Divider names come from the uploaded document title.',
    PENDING_WARNING: 'changes are still undecided and will not be included in the output.',
    BUTTON: {
      SAVE_ORDER: 'Save order',
      ACCEPT_ORDER: 'Accept order',
      SAVING_ORDER: 'Saving order...',
      BACK_TO_REVIEW: 'Back to review',
      PREVIEW: 'Preview report',
      PREVIEWING: 'Preview in progress',
      GENERATE_PDF: 'Download updated PDF',
      DOWNLOAD_DOCX: 'Download updated .docx',
      EXPORTING: 'Generating',
    },
    TOASTER: {
      LOAD_FAILED: 'Failed to load the supporting documents for this report.',
      ORDER_SAVED: 'Attachment order saved ({count} updated).',
      ORDER_SAVE_FAILED: 'Failed to save the attachment order. Please try again.',
      EXPORT_FAILED: 'Failed to generate the file. Please try again.',
      PREVIEW_FAILED: 'Failed to generate the preview. Please try again.',
      PREVIEW_NO_FILE: 'The preview finished but no file path was returned.',
      PREVIEW_TIMEOUT: 'The preview is taking longer than expected. Try again in a moment.',
    },
  },
  REVIEW_REFINE: {
    EYEBROW: 'Report Update · ',
    REVIEW:'Review',
    NOTE: 'Note : Proposed changes are generated by AI from your data files. Review each one before confirming.',
    CONTENTS: 'Contents',
    PROJECT_ID: 'Project ID :',
    OWNER: 'Owner :',
    CREATED: 'Created Date :',
    DATA_SOURCE: 'data source',
    DATA_SOURCES: 'data sources',
    SECTIONS: 'sections',
    SHOWING: 'Showing',
    OF: 'of',
    CLEAR_FILTER: 'Clear filter',
    APPLY_HINT:
      'Writes your accepted changes into a copy of the report. Accept and decline are saved as you go.',
    CHANGE_ONE: 'change',
    CHANGE_MANY: 'changes',
    FILTER_HINT: 'Filter the sections below',
    CHANGED: 'Changed',
    CONFIRMED: 'Confirmed',
    REVIEWED: 'Reviewed',
    UNCHANGED: 'Unchanged',
    REVIEW_REQUIRED: 'Review Required',
    FLAGS: 'Flags',
    FLAG_REASON: 'Filter the sections below',
    CHANGE_REVIEW: 'Change review',
    DECIDED: 'decided',
    ACCEPTED: 'Accepted',
    DECLINED: 'Declined',
    PENDING: 'Pending',
    SOURCE: 'Source',
    RATIONALE: 'Rationale',
    VERIFY_BEFORE_CONFIRMING: 'heuristic match — verify before confirming',
    CONFLICTING_SOURCE: 'Conflicting values found in the data — check the source before confirming.',
    UNTRACEABLE_SOURCE: 'This value could not be traced to the ingested data.',
    NEEDS_VALUE: 'The detector could not fill this value. Edit it to supply the replacement.',
    NO_PROPOSED_VALUE: 'No proposed value',
    EDITED: 'Edited',
    CONFIDENCE: 'Confidence',
    EDIT_PLACEHOLDER: 'Enter the replacement text...',
    SECTION_EDIT_PLACEHOLDER: 'Edit the section text. Leave a blank line between paragraphs.',
    PREVIEW_CURRENT: 'Original document',
    PREVIEW_NEW: 'New (updated) document',
    COMPARISON: 'Side-by-side comparison',
    CHANGE_DETAIL: {
      TITLE_SUFFIX: 'Review',
      DATA_PROVENANCE: 'Data provenance',
      DOCX_TO_PDF: '.docx → PDF',
      TEXT_PREVIEW: 'text preview — PDF conversion not available',
      SAMPLE_RENDER: 'sample render · conversion service pending',
      REGENERATED: 'regenerated with this change',
      FORMAT_LABEL: 'Format',
      FORMAT_NOTE:
        'Only the differing characters are rewritten — a number inside a bold run stays bold. Original formatting preserved.',
      EDIT_TEXT: 'Edit',
      REPLACEMENT_TEXT: 'Replacement text',
      REPLACE_HINT: 'will be replaced with your text.',
      SAVE_EDIT: 'Save',
      SHOW_PREVIEW: 'Show preview',
      REFRESH_PREVIEW: 'Refresh preview',
      REFRESHING: 'Refreshing...',
      PREVIEW_STALE: 'Preview does not include your latest edit.',
      PREVIEW_LOADING: 'Loading preview...',
      PREVIEW_UNAVAILABLE: 'The preview could not be loaded.',
      PREVIEW_NOT_GENERATED: 'Refresh to generate a preview with these changes.',
      RETRY: 'Retry',
      HIDE_PREVIEW: 'Hide preview',
      ACCEPT_CHANGE: 'Accept',
      CLOSE_ARIA: 'Close change detail',
    },
    NO_CHANGES: 'No changes were detected in this section.',
    EMPTY_STATE: 'No review state is available for this report.',
    ALL_DECIDED: 'All changes decided. You can apply them and move on to compile & export.',
    BUTTON: {
      ACCEPT: 'Accept',
      EDIT: 'Edit',
      DECLINE: 'Decline',
      SAVE: 'Save',
      CANCEL: 'Cancel',
      PREVIEW: 'Review',
      EDIT_SECTION: 'Edit',
      APPLY: 'Apply',
      COMPILE_EXPORT: 'Compile & Export',
    },
    TOASTER: {
      LOAD_FAILED: 'Failed to load the review state for this report.',
      DECISION_FAILED: 'Failed to record your decision. Please try again.',
      EDIT_REQUIRES_VALUE: 'Enter a replacement value before saving.',
      EDIT_SAVED: 'Edit saved. Accept the change to include it.',
      CHANGE_ACCEPTED: 'Change accepted.',
      CHANGE_DECLINED: 'Change declined.',
      SECTION_REQUIRES_TEXT: 'Enter the section text before saving.',
      SECTION_SAVED: 'Section updated and captured as a manual change.',
      SECTION_SAVE_FAILED: 'Failed to save the section. Please try again.',
      SECTION_LOAD_FAILED: 'Failed to load the section for editing. Please try again.',
      SECTION_RELOAD_REQUIRED:
        'The document has changed since this section was opened. Reload the section and re-apply your edits.',
      APPLY_TITLE: 'Document updated',
      APPLY_RESULT: 'Updated .docx generated from {applied} accepted {appliedNoun}.',
      APPLY_LEFT_OUT_ONE: '1 undecided change was left out.',
      APPLY_LEFT_OUT_MANY: '{pending} undecided changes were left out.',
      APPLY_PENDING: 'Decide the remaining changes before continuing.',
      APPLY_FAILED_TITLE: "Couldn't update document",
      APPLY_FAILED: 'The updated .docx could not be generated. Please try again.',
    },
  },
  REPORT_SECTIONS: {
    NOTE: 'Note : This content is generated by AI. Please review it carefully.',
    TABLE_OF_CONTENTS: 'Table of Contents',
    AVERAGE_QUALITY_SCORE: 'Average Quality Score:',
    REPORT_ID: 'Report ID #',
    STATUS: 'Status : ',
    OVERALL_QUALITY: 'Overall Quality :',
    REPORT_TYPE: 'Report Type :',
    AVERAGE_QUALITY_SCORE_ARIA: 'Open Average Quality Score',
    ADD_SUB_SECTION: 'Add as a Sub Section',
    CLIENT_NAME: 'Client Name : ',
    LOCATION_NAME: 'Location Name : ',
    CREATED_BY: 'Created By : ',
    COMMENTS_COUNT: 'Comments Count : ',
    REFERRENCES: 'References',
    APPROVAL_DIALOG_TITLE: 'Ready for Review',
    COMMENT:'Comments for Report ID #',
    ENTER_COMMENT:'Enter your comments here...',
    APPROVE_SECTION_TITLE: 'Approve Section',
    FEEDBACK_OPTIONAL: 'Feedback (Optional)',
    FEEDBACK_PLACEHOLDER: 'Enter your feedback comments...',
    SEARCH_REVIEWERS_PLACEHOLDER: 'Search by name or email...',
    COMMENT_CLEAR:'Clear',
    SELECT_POSTION:'Select Position',
    SElECT_SITE_MANAGER:'Assign this to a member of your team for review',
    SECTION_TITLE:'Section Title',
    SECTION_NUMBER:'Section Number',
    SECTION_CONTENT:'Section Content',
    COMMENT_POST:'Post',
    BUTTON: {
      ADD_SECTION: 'Add Section',
      SUBMIT_FOR_APPROVAL: 'Submit for Approval',
      ASSIGN_FOR_APPROVAl: 'Assign',
      SEND_FOR_REVISION: 'Send For Revision',
      APPROVE_REPORT: 'Approve',
      AGENT_REWORK: 'Send to Agents for Rework',
      PUBLISH_REPORT: 'Publish',
    },
  },
  UPDATE_FROM_DATA: {
    TITLE: 'Start a new update · ',
    SUBTITLE: 'Add your files, then run the review',
    PRIOR_REPORT_TITLE: 'Previous Report',
    PRIOR_REPORT_SUBTITLE: 'Word document - .docx, .dotx',
    DATA_FILES_TITLE: 'Data / Ingredients',
    DATA_FILES_SUBTITLE: 'Excel or CSV - .xlsx, .xls, .csv',
    NO_FILE_SELECTED: 'No file selected',
    REPORT_PERIOD_TITLE: 'Report period',
    REPORT_PERIOD_HINT: 'Flags any date in the report earlier than the period start.',
    DURATION_LABEL: 'Duration',
    DURATION_PLACEHOLDER: 'Select duration',
    START_MONTH_YEAR_LABEL: 'Start (month / year)',
    ADDITIONAL_SECTIONS_TITLE: 'Additional sections',
    ADDITIONAL_SECTIONS_HINT: 'Optional - a label and a PDF. Maximum of 8 sections.',
    SECTION_LABEL_PLACEHOLDER: 'Section label (e.g. Attachment A - Groundwater Monitoring Summary)',
    CHOOSE_PDF: 'Choose PDF',
    REMOVE_SECTION_TITLE: 'Remove this section',
    REMOVE_SECTION_BUTTON: 'x',
    ADD_SECTION_BUTTON: '+ Add section',
    REPORT_DETAILS_TITLE: 'Report Details',
    REPORT_DETAILS_HINT: 'Enter report name, select report type, and provide the 8-digit project ID.',
    REPORT_NAME_LABEL: 'Report Name',
    REPORT_NAME_PLACEHOLDER: 'Enter report name',
    REPORT_TYPE_LABEL: 'Report Type',
    REPORT_TYPE_PLACEHOLDER: 'Select report type',
    PROJECT_ID_LABEL: 'Project ID',
    PROJECT_ID_PLACEHOLDER: '8-digit project ID',
    ANALYZE_REPORT_BUTTON: 'Analyze Report',
  },
};
